import { error99, RetAPI, SubGrupoDespesa } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const SubGrupoDespesaService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('SGrupoDespesa/attributes', 'get', { id })
        const attributes: SubGrupoDespesa = {
            id: 0,
            description: '',
            id_user_insert: 0,
            id_user_last_update: 0,
            dt_cadastro: '',
            dt_last_update: '',
            name_user_insert: '',
            name_user_last_update: '',
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.sgdespesa) {

                    attributes.id = resp.data.sgdespesa.id
                    attributes.description = resp.data.sgdespesa.descricao
                    attributes.id_user_insert = resp.data.sgdespesa.id_user_insert
                    attributes.id_user_last_update = resp.data.sgdespesa.id_user_last_update
                    attributes.dt_cadastro = resp.data.sgdespesa.dt_cadastro
                    attributes.dt_last_update = resp.data.sgdespesa.dt_last_update
                    attributes.name_user_insert = resp.data.sgdespesa.name_user_insert
                    attributes.name_user_last_update = resp.data.sgdespesa.name_user_last_update

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (sgrupoDespesa: any): Promise<RetAPI> => {

        let id = ''

        if (sgrupoDespesa.id) {
            id = sgrupoDespesa.id.toString()
        }

        const resp = await Api('SGrupoDespesa/save', 'post', {

            descricao: sgrupoDespesa.description,
            id

        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            return {
                error: false,
                msg: 'Dados do subgrupo de despesa gravados com sucesso',
                id: resp.data.sgdespesa.id,
                data: resp.data,
                dt_cadastro: resp.data.sgdespesa.dt_cadastro,
                dt_last_update: resp.data.sgdespesa.dt_last_update,
                name_user_insert: resp.data.sgdespesa.name_user_insert,
                name_user_last_update: resp.data.sgdespesa.name_user_last_update
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`SGrupoDespesa/delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<RetAPI> => {

        const resp = await Api('SGrupoDespesa/filter', 'get', { field, filter_type, filter, id })
        const sgrupoDespesa: SubGrupoDespesa[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: sgrupoDespesa
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.sgdespesa.map((item: any) => {
                    return sgrupoDespesa.push({

                        id: item.id,
                        description: item.descricao,
                        dt_cadastro: item.dt_cadastro,
                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: sgrupoDespesa
            }
        }

        return {
            error: false,
            data: sgrupoDespesa
        }

    },

    Relatorio: async (datai: string, dataf: string, descricao?: string, mostrar_excluidas?: string): Promise<RetAPI> => {

        const resp = await Api('SGrupoDespesa/Report/relatorio', 'get', { datai, dataf, descricao, mostrar_excluidas })
        const subGrupoDesp: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: subGrupoDesp
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.sgrupo_despesa.map((item: any) => {
                    return subGrupoDesp.push({

                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        descricao: item.descricao,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: subGrupoDesp
            }
        }

        return {
            error: false,
            data: subGrupoDesp,
        }

    }
}
